import { Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CurrencyFormatterDirective } from '@hub/directives/currencyFormatter.directive';
import { CurrencyDto } from '@hub/generated/models';
import { CurrencyInputPipe } from '@hub/pipes/CurrencyInput.pipe';
import { FormEventService } from '@hub/services/form-event.service';
import { BaseErrorForm } from '@hub/common/BaseErrorForm';

const noop = () => {};

export const CUSTOM_CURRENCY_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => FormCurrencyComponent),
  multi: true
};

@Component({
  selector: 'fm-currency',
  templateUrl: 'form-currency.component.html',
  providers: [CUSTOM_CURRENCY_CONTROL_VALUE_ACCESSOR]
})
export class FormCurrencyComponent extends BaseErrorForm
  implements ControlValueAccessor, OnInit, OnDestroy {
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    public formEventService: FormEventService
  ) { super(); }

  @Input() public type: string;
  @Input() public showCurrencySymbol: boolean = false;
  @Input() public disabled: boolean = false;
  @Input() public currency: CurrencyDto;
  @ViewChild('in') public input: ElementRef;
  @ViewChild(CurrencyFormatterDirective)
  currencyFormatterDirective: CurrencyFormatterDirective;
  public tabindex: string;
  @Input('tabindex')
  public set tabind(val: string) {
    this.tabindex = String(val);
  }

  public isFocused: boolean = false;
  public inputType: string;
  private numOfTabs: number = 0;
  private innerValue: any;
  private currencyPipe: CurrencyInputPipe = new CurrencyInputPipe();
  //Placeholders for the callbacks which are later provided
  //by the Control Value Accessor
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  ngOnInit() {
    if (this.type) {
      this.inputType = this.type;
    } else {
      this.inputType = 'text';
    }
    this.formEventService.setIndex(parseInt(this.tabindex));
    const elem: HTMLElement = this.el.nativeElement;
    this.renderer.setStyle(elem, 'outline', 'none');
  }

  public ngOnDestroy(): void {}
  public getSymbol(): string {
    return this.currency && this.currency.Symbol != ''
      ? this.currency.Symbol
      : '$';
  }

  get value(): any {
    return this.innerValue;
  }

  // set accessor including call the onchange callback
  set value(v: any) {
    if (v !== this.value) {
      this.writeValue(v);
      this.onChangeCallback(v);
    }
  }

  //From ControlValueAccessor interface
  public writeValue(value: any) {
    if (value && value !== this.innerValue) {
      if (this.innerValue == '0.00') {
          this.innerValue = '';
        }
        else {
           this.innerValue = value;
        }
    }
    if (!this.isFocused) {
      this.innerValue = this.currencyPipe.transform(value);
    }
  }

  onFocus(value) {
    this.isFocused = true;
    this.writeValue(this.currencyPipe.parse(value)); // opossite of transform
  }

  onBlur(value) {
    this.isFocused = false;
    this.innerValue = this.currencyPipe.transform(value);
  }

  //From ControlValueAccessor interface
  public registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  //From ControlValueAccessor interface
  public registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }
}


